<template>
  <div class="dialog-wrapper" style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="50%"
               @close="init()">
      <h3 class="text-center" style="margin-bottom:20px;">创建监控</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <!--<div v-if="showText" style="margin-bottom:10px;">您尚未设置提现方式. <a href="/buyer/withdraw" style="cursor: pointer;"> 现在添加.</a></div>-->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="" prop="express_type">
              <el-select style="width:100%;" v-model="form.express_type" clearable filterable

                         class="block height-50" placeholder="物流类型">
                <el-option v-for="item in expressTypeOption" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" prop="express_company_id">
              <el-select style="width:100%;" v-model="form.express_company_id" clearable filterable

                         class="block height-50" placeholder="物流公司">
                <el-option v-for="item in expressCompanyList" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" prop="express_order_id">
              <YueDanIpt style="width:100%;" model="express_order_id" :object="form" placeholder="物流单号"/>
            </el-form-item>
            <el-form-item label="" prop="express_link">
              <YueDanIpt style="width:100%;" model="express_link" :object="form" placeholder="物流链接"/>
            </el-form-item>
            <el-form-item label="" prop="related_merchant_id">
              <el-select class="block height-50" v-model="form.related_merchant_id" clearable filterable
                         placeholder="关联商家">
                <el-option v-for="item in businessOption" :key="item.id" :label="item.merchant_name"
                           :value="item.merchant_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" prop="related_task_id">
              <YueDanIpt style="width:100%;" model="related_task_id" :object="form" placeholder="关联任务"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="monitor_type">
              <el-select class="block height-50" v-model="form.monitor_type" placeholder="监控类型"
                         allow-create
                         filterable>
                <el-option label="物流进展" value="1"></el-option>
                <el-option label="包裹揽收" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select class="block height-50" v-model="form.monitor_flag" placeholder="监控开启"
                         allow-create
                         filterable>
                <el-option label="开启" value="1"></el-option>
                <el-option label="关闭" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="group_tag">
              <el-select class="block height-50" v-model="form.group_tag" placeholder="监控分组"
                         allow-create
                         filterable>
                <el-option v-for="(item, index) in monitorGroupList" :key="index" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="monitor_start_time">
              <el-date-picker class="block height-50" style="width: 100%" format="yyyy-MM-dd HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              v-model="form.monitor_start_time" type="datetime"
                              placeholder="监控开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="monitor_keyword">
              <YueDanIpt style="width:100%;" model="monitor_keyword" :object="form" placeholder="监控关键字"/>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!showText">
        <el-button class="block" type="primary" @click="submit()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import api from '../../../services/api.js'
  import YueDanIpt from '../../../components/YueDanIpt'

  let _ = require('lodash')


  export default {
    name: 'AddForm',
    props: ['expressTypeOption', 'expressCompanyList', 'businessOption', 'monitorGroupList', 'monitorTypeOption'],
    components: {
      YueDanIpt: YueDanIpt
    },
    data() {
      return {
        dialogFormVisible: false,
        loading: false,
        errors: null,
        list: null,
        showText: false,
        isEmptyErrors: true,
        form: {},
        rules: {
          express_type: [
            {required: true, message: '物流类型必填', trigger: 'change'}
          ],
          express_company_id: [
            {required: true, message: '物流公司必填', trigger: 'change'}
          ],
          express_order_id: [
            {required: true, message: '物流单号必填', trigger: 'change'}
          ],
          group_tag: [
            {required: true, message: '分组必填', trigger: 'change'}
          ],
          monitor_type: [
            {required: true, message: '监控类型必填', trigger: 'change'}
          ],
          monitor_start_time: [
            {required: true, message: '监控开始时间必填', trigger: 'change'}
          ],
          monitor_keyword: [
            {required: true, message: '监控关键字必填', trigger: 'change'}
          ],
        }
      }
    },
    methods: {
      init() {
        this.form = {
          express_type: '',
          express_company_id: '',
          express_order_id: '',
          express_link: '',
          related_merchant_id: '',
          related_task_id: '',
          monitor_flag: '1',
          group_tag: '',
          monitor_type: '',
          monitor_start_time: '',
          monitor_keyword: '',
        }
        this.isEmptyErrors = true
      },
      show() {
        this.init()
        this.dialogFormVisible = true;

      },
      submit() {
        this.$refs['form'].validate(async (valid, errors) => {
          this.isEmptyErrors = _.isEmpty(errors)
          this.errors = errors
          let param = JSON.parse(JSON.stringify(this.form));
          if (valid) {
            this.loading = true
            let res = await api.addMonitor(this, param)
            this.loading = false
            if (res.body.status == 'ok') {
              this.$emit('success')
              this.dialogFormVisible = false
            }
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-item {
    display: flex;
    justify-content: space-between;
  }

  .detail-table-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    padding-bottom: 10px;
  }

  .detail-table-body {
    max-height: 300px;
    overflow: auto;
  }

  .detail-table-row {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    padding: 10px 0;
    align-items: center;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/express_monitor/Create.vue